import { FALLBACK_TRANSLATIONS } from '../../locale/translations';

const en: any = FALLBACK_TRANSLATIONS.optimized_checkout


export default class LanguageService {

  langCodeList: string[]
  langList: any
  currentLangCode: string


  constructor() {
    this.langCodeList = []
    this.langList = { en }
    this.currentLangCode = "en"
  }

  static create() {
    const instance = new this()
    instance.createLangCodeList()
    instance.createLangList()
    instance.setCurrentLangCode()
    const showLangList = instance.setLangList()
    return showLangList
  }

  createLangCodeList() {
    if ((window as any).b3themeConfig?.lang) this.langCodeList.push((window as any).b3themeConfig.lang)
    const { languages = [], language } = navigator
    let langCodeList: string[] = [...this.langCodeList, ...languages, language]
    this.langCodeList = [...new Set(langCodeList)].filter(language => language)
  }

  createLangList() {
    this.langList = {
      ...this.langList,
      ...(window as any).B3checkoutLanguageConfig?.locales ?? {}
    }
  }

  setCurrentLangCode() {
    for (let i: number = 0; i < this.langCodeList.length; i++) {
      if (this.langList.hasOwnProperty(this.langCodeList[i])) {
        this.currentLangCode = this.langCodeList[i]
        break;
      }
      if (this.langList.hasOwnProperty(this.langCodeList[i].substring(0, 2))) {
        this.currentLangCode = this.langCodeList[i].substring(0, 2)
        break;
      }
    }
  }

  setLangList() {
    (window as any).language.locale = this.currentLangCode

    let langList  =  this.currentLangCode === 'en' ? this.langList[this.currentLangCode] : {...en, ...this.langList[this.currentLangCode]}
    // set custom language
    if (langList.tips) {
      (window as any).b3CheckoutConfigTips = langList.tips
    }

    return langList
  }
}
